import Api from "@/api/index";
// import store from "@/store";
// import alerts from "@/components/alerts/alert";
// import router from "@/router";

const home = {
  namespaced: true,
  state: {
    datas: {},
    queryParam: {},
    menu: [],
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
  },
  actions: {},
};

export default home;
